import axios from "axios";

const http = {
  get: axios.get,
  post: axios.post,
  delete: axios.delete,
  put: axios.put,
  patch: axios.patch,
  headers: axios.defaults.headers,
};

export default http;
